//CHECKS Listing
export const FETCH_TAXES_LISTING_SUCCESS = 'FETCH_TAXES_LISTING_SUCCESS';
export const FETCH_TAXES_LISTING_FAILURE = 'FETCH_TAXES_LISTING_FAILURE';

export const RESET = 'RESET';
